<script lang="ts">
    import { Link } from "svelte-routing";
    import { replace } from "svelte-spa-router";
    import * as animateScroll from "svelte-scrollto";
    import { apiServer, headerScrollHeights } from "../../constant";
    import { onMount } from "svelte";
    import Cookie from "./cookie.svelte";
    import { getContext } from "svelte";
    import { section_pointer, step_pointer } from "../../store";
    
    const { open } = getContext('simple-modal');
    const showSurprise = (content) => open(Cookie, { content: { isLoaded: true, content: cookie } });

    let footer = {};
    let cookie = '';
    let error = null;
    onMount(async () => {
        fetch(apiServer + '/api/footer?populate=footer.logo&populate=footer.socials.icon&populate=footer.menus.items', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then(response => response.json())
        .then(data => {
            footer = data.data.attributes.footer;
        })
        .catch(e => error = e)

        fetch(apiServer + '/api/cookiepreferences?populate=*', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then(response => response.json())
        .then(data => {
            cookie = data.data.attributes.cookie.content;
        })
        .catch(e => error = e)
    });

    let isMobile;

    $: dispatchResize()

    const dispatchResize = () => {
        isMobile = window.innerWidth < 1000;
    }
</script>
<svelte:window on:resize={dispatchResize}></svelte:window>
<div class="footer">
    {#if Object.keys(footer).length}
    <div class="footer-content">
        <div class="footer-item">
            <Link to="/home">
                <img 
                    src={apiServer + ((footer && footer['logo'].data) ? footer['logo'].data.attributes.url : '')}
                    alt={((footer && footer['logo'].data) ? footer['logo'].data.attributes.alternativeText : '')}
                    class="logo"
                />
            </Link>
            <a href="tel:818-927-3458">
                <div class="footer-text">{footer['contact']}</div>
            </a>
            <a href="mailto:hello@houseofyards.com">
                <div class="footer-text">{footer['email']}</div>
            </a>
            <div class="socials">
                {#each footer['socials'] as social}
                    <a href={social.href} target="__blank" rel="noreferrer">
                        <img
                            src={apiServer + ((social.icon && social.icon.data) ? social.icon.data.attributes.url : '')}
                            alt={((social.icon && social.icon.data) ? social.icon.data.attributes.alternativeText : '')}
                            class="social"
                        />
                    </a>
                {/each}
            </div>
            <!-- <div class="copyright">© {new Date().getFullYear()} Gigconcept Inc. All rights reserved.</div> -->
            <div class="copyright">{footer['copyright']}</div>
        </div>
        <div class="footer-item" style="display: flex;">
            <!-- Features -->
            <div class="footer-item">
                <Link to="/how-it-works" on:click={() => {step_pointer.set('step1')}}>
                    <div class='item-header'>
                        {footer['menus'][0].title}
                    </div>
                </Link>
                {#each footer['menus'][0].items as feature, i}
                    {#if (feature.action.replace(/[0-9]/g, '') === 'step')}
                        <Link to={`/how-it-works`} on:click={() => {
                            step_pointer.set(feature.action);
                        }}>
                            <div class='item'>{feature.label}</div>
                        </Link>
                    {:else}
                        <Link to={feature.action}>
                            <div class='item'>{feature.label}</div>
                        </Link>
                    {/if}
                {/each}
            </div>
            <div class="footer-item">
                <!-- Company -->
                <div class='item-header'>
                    {footer['menus'][1].title}
                </div>
                {#each footer['menus'][1].items as infoItem, i}
                    <Link to="/home">
                        <div
                            class='item'
                            on:click={() => {
                                if (infoItem.label === 'Cookie Preferences') {
                                    showSurprise('this is cookie preferences');
                                    return;
                                }
                                if (i === 0) { section_pointer.set('section14'); return }
                                window.open(infoItem.action, '_blank');
                            }}
                        >
                            {infoItem.label}
                        </div>
                    </Link>
                {/each}
                <!-- Resources -->
                <div style="margin-top: 40px">
                    <a href='/' target="__blank" rel="noreferrer">
                        <div class='item-header'>{footer['menus'][2].title}</div>
                    </a>
                    {#each footer['menus'][2].items as resource, i}
                        <a href={resource.action} target="__blank" rel="noreferrer">
                            <div class='item'>{resource.label}</div>
                        </a>
                    {/each}
                </div>
            </div>
        </div>
        <div class="mobcopyright">{footer['copyright']}</div>
    </div>
    {/if}
</div>
<style>
    .item-header {
        font-size: 14px;
        color: #fff;
        font-weight: 500;
        margin-bottom: 20px;
    }
    .item {
        cursor: pointer;
        font-size: 14px;
        margin-bottom: 20px;
        font-weight: 300;
        color: #ffffff95;
    }
    .item:hover {
        color: white;
    }
    .copyright {
        font-size: 12px;
        font-weight: 300;
    }
    .social {
        width: 24px;
        height: 24px;
        margin-right: 25px;
    }
    .social:hover {
        opacity: .7;
    }
    .socials {
        display: flex;
        align-items: center;
        margin-bottom: 70px;
    }
    .footer {
        background-color: #222A1B;
        padding-top: 50px;
        padding-bottom: 70px;
        color: #fff;
        position: relative;
        z-index: 1;
    }
    .footer-content {
        width: 1280px;
        margin: auto;
        display: flex;
    }
    .footer-item {
        width: 50%;
    }
    .logo {
        width: 200px;
        height: 65px;
        margin-bottom: 30px;
    }
    .footer-text {
        font-weight: 600;
        font-size: 18px;
        margin-bottom: 30px;
        color: #fff;
    }
    .mobcopyright {
        display: none;
    }
    @media (max-width: 1300px) {
        .footer {
            padding-left: 20px;
            padding-right: 20px;
        }
        .footer-content {
            width: 100%;
        }
    }
    @media (max-width: 700px) {
        .footer-content {
            display: block;
        }
        .footer-item {
            width: 100%;
        }
        .copyright {
            display: none;
        }
        .mobcopyright {
            display: block;
            font-size: 14px;
            margin-top: 40px;
        }
        .footer-text {
            font-size: 16px;
        }
    }
</style>